module.exports = __webpack_public_path__ + "static/media/ic_ignore_hover.b2d3cc8d.svg";